module.exports = __webpack_public_path__ + "img/exam.85992a89.svg";